import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Product } from 'src/services/product';
import { ProductService } from '../../services/productservice';
import { Carousel } from 'primeng/carousel';

@Component({
  selector: 'app-islands',
  templateUrl: './islands.component.html',
  styleUrls: ['./islands.component.scss'],
})
export class IslandsComponent implements OnInit {
  public title: string;
  public subtitle: string;
  public inner: string;
  products: Product[];
  responsiveOptionsActivity: any;
  responsiveOptions: any;
  islandsWithAccom: any;
  islandsWithoutAccom: any;
  islandType: any;
  islandsBannerAndContent: any = { bannerImage: null, bannerTitle: null, content: null };
  bannerImage: any;
  outerIslandGroups: any;
  viewNode: any;
  language: any;
  images: any = [];
  activeIndex: any;
  displayCustom: boolean;

  constructor(private route: ActivatedRoute, private productService: ProductService, private router: Router) {
    Carousel.prototype.onTouchMove = () => {};
    this.responsiveOptions = [
      {
        breakpoint: '1024px',
        numVisible: 3,
        numScroll: 1,
      },
      {
        breakpoint: '768px',
        numVisible: 2,
        numScroll: 1,
      },
      {
        breakpoint: '640px',
        numVisible: 2,
        numScroll: 1,
      },
      {
        breakpoint: '480px',
        numVisible: 1,
        numScroll: 1,
      },
    ];
  }

  ngOnInit(): void {
    this.language = localStorage.getItem('language');
    this.route.queryParams.subscribe((params) => {
      this.islandType = params['islandType'];
      this.getDetails();
    });
  }
  getDetails() {
    if (this.islandType == 'innerIslands') {
      this.productService.getInnerIslandsWithAccom().then((innerIslands) => {
        if (innerIslands) {
          this.islandsWithAccom = innerIslands;
        }
      });
      this.productService.getInnerIslandsWithoutAccom().then((innerIslands) => {
        if (innerIslands) {
          this.islandsWithoutAccom = innerIslands;
        }
      });
      this.productService.getinnerIslandsBannerAndContent().then((innerIslands) => {
        if (innerIslands) {
          this.islandsBannerAndContent = innerIslands;
          if (this.islandsBannerAndContent.bannerImage) {
            this.bannerImage = this.islandsBannerAndContent.bannerImage;
          } else {
            this.bannerImage = '../../../assets/images/NoImage.jpg';
          }
          this.images = [];
          this.images.push(this.bannerImage);
        }
      });
    } else if (this.islandType == 'outerIslands') {
      this.productService.getOuterIslandsWithAccom().then((outerIslands) => {
        if (outerIslands) {
          this.islandsWithAccom = outerIslands;
        }
      });
      this.productService.getOuterIslandsWithoutAccom().then((outerIslands) => {
        if (outerIslands) {
          this.islandsWithoutAccom = outerIslands;
        }
      });
      this.productService.getouterIslandsBannerAndContent().then((outerIslands) => {
        if (outerIslands) {
          this.islandsBannerAndContent = outerIslands;
          if (this.islandsBannerAndContent.bannerImage) {
            this.bannerImage = this.islandsBannerAndContent.bannerImage;
          } else {
            this.bannerImage = '../../../assets/images/NoImage.jpg';
          }
          this.images = [];
          this.images.push(this.bannerImage);
        }
      });
      this.productService.getIslandGroups().then((islandGroups) => {
        if (islandGroups) {
          this.outerIslandGroups = islandGroups;
        }
      });
    }
  }

  islands(view_node: string) {
    /*let url;
    if (view_node.indexOf('/fr/') > -1) {
      url = view_node.split('/fr/');
      this.viewNode = url[1];
    } else if (view_node.indexOf('/de/') > -1) {
      url = view_node.split('/de/');
      this.viewNode = url[1];
    } else if (view_node.indexOf('/it/') > -1) {
      url = view_node.split('/it/');
      this.viewNode = url[1];
    } else if (view_node.indexOf('/es/') > -1) {
      url = view_node.split('/es/');
      this.viewNode = url[1];
    } else if (view_node.indexOf('/ru/') > -1) {
      url = view_node.split('/ru/');
      this.viewNode = url[1];
    } else if (view_node.indexOf('/zh-hans/') > -1) {
      url = view_node.split('/zh-hans/');
      this.viewNode = url[1];
    } else if (view_node.indexOf('/pt-br/') > -1) {
      url = view_node.split('/pt-br/');
      this.viewNode = url[1];
    } else {
      url = view_node.substring(1, view_node.length);
      this.viewNode = url;
    }*/
    this.viewNode = this.productService.getBlogViewNode({ view_node: view_node });
    this.router.navigate(['/island-details'], {
      queryParams: { view_node: this.viewNode },
    });
  }
  islandsAll(islandType: any, islandsAccom: any) {
    this.router.navigate(['/islands-all'], {
      queryParams: { islandType: islandType, IslandsAccom: islandsAccom },
    });
  }
  islandsAllGroups(islandType: any, islandsGroup: any) {
    this.router.navigate(['/islands-all'], {
      queryParams: { islandType: islandType, islandsGroup: islandsGroup },
    });
  }
  islandGroups(menu: any) {
    this.router.navigate(['/island-groups'], {
      queryParams: { id: menu.tid },
    });
  }

  imageClick(index: number) {
    this.activeIndex = index;
    this.displayCustom = true;
  }
}
